import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Client from './pages/Client';
import Home from "./pages/Home";
import PaymentSuccessPage from './pages/PaymentSuccessPage';
import PaymentPendingPage from './pages/PaymentPendingPage';
import PaymentFailurePage from './pages/PaymentFailurePage';
import NotFound from './pages/NotFound';
import NotFoundWithToken from './pages/NotFoundWithToken';
import MaintenanceScreen from './components/MaintenanceScreen';
import GoogleAnalytics from './components/GoogleAnalytics';
import './styles/icons.css';
import './styles/loans.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Check if maintenance mode is enabled
const isMaintenanceMode = process.env.REACT_APP_MAINTENANCE_MODE === 'true';

root.render(
    isMaintenanceMode ? (
        <MaintenanceScreen />
    ) : (
        <Router>
            <GoogleAnalytics />
            <Routes>
                <Route path="/" element={<Home />} />
                {/* Payment routes with token */}
                <Route path="/:uid/payment/success" element={<PaymentSuccessPage />} />
                <Route path="/:uid/payment/pending" element={<PaymentPendingPage />} />
                <Route path="/:uid/payment/failure" element={<PaymentFailurePage />} />
                {/* Client home */}
                <Route path="/:uid" element={<Client />} />
                {/* 404 with token context - catches /:uid/* that don't match above */}
                <Route path="/:uid/*" element={<NotFoundWithToken />} />
                {/* 404 generic - catches everything else */}
                <Route path="*" element={<NotFound />} />
            </Routes>
        </Router>
    )
);

